<template>
  <div>
  <Card>
      <!-- <Row>
        <i-col span="18">
          <Form ref="searchForm" inline :model="searchForm" :label-width="60" @submit.native.prevent>
            <FormItem prop="name" :label-width="0">
              <i-input v-model="searchForm.name" placeholder="请输入Disk Name" style="width: 200px;"></i-input>
            </FormItem>
            <FormItem :label-width="0">
              <Button type="primary" @click="getDiskList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
       </Row> -->
      <tables search-place="top" v-model="tableData" :columns="columns"/>
      <!-- <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getDiskList"></page>
        </div>
     </Row> -->
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getDiskList } from '@/api/emc'
export default {
  name: 'DiskList',
  components: {
    Tables
  },
  data () {
    return {
      count: 1,
      size: 10,
      page: 1,
      change: false,
      ordering: null,
      columns: [
        { title: 'ID', key: 'id', align: 'center' },
        { title: 'name', key: 'name', align: 'center' },
        { title: 'slotNumber', key: 'slotNumber', align: 'center' },
        { title: 'emcSerialNumber', key: 'emcSerialNumber', align: 'center' },
        { title: 'currentSpeed', key: 'currentSpeed', align: 'center' },
        { title: 'model', key: 'model', align: 'center' },
        { title: 'size', key: 'size', align: 'center' },
        { title: 'version', key: 'version', align: 'center' },
        { title: 'manufacturer', key: 'manufacturer', align: 'center' }
      ],
      tableData: [],
      searchForm: {
        name: null
      },
      listStyle: {
        width: '250px',
        height: '300px'
      }
    }
  },
  watch: {
  },
  methods: {
    getDiskList () {
      getDiskList().then(res => {
        this.tableData = res.data.data
        this.count = res.data.data.count
      })
    },
    searchReset () {
      this.searchForm.name = null
    }
  },
  mounted: function () {
    this.getDiskList()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
.ivu-input[disabled], fieldset[disabled] .ivu-input {
    background-color: #f3f3f3;
    opacity: 1;
    cursor: not-allowed;
    color: #666;
}
</style>
